import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Career.css";
import { useNavigate } from "react-router-dom";

function Career() {
    let navigate = useNavigate();
    const [data, setData] = useState(false);
    var [filterLocation, setFilterLocation] = useState([]);
    var [filterDepartment, setFilterDepartment] = useState([]);
 
    const routeChangeToCareer = (job_id) => {
        
        navigate("/CareersInner/" + job_id, {
            //state: { id: `${getDExchange}`, coCode: `${getCoCodeId}` },
        });
    };

    useEffect(() => {
       var url_Job_id = window.location
       url_Job_id = url_Job_id.href.split("/")[4]
        postData('/api/Login/Career', {"job_id":url_Job_id })
            .then((data) => {
                if (data.data != null && data.data.length > 0) {
                    setData(data.data);
                   // console.log("data: ", data)
                }
                else { setData(null); }
            });
    }, []);

    async function postData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header

        });
        //console.log(response, "careerdata");
        return response.json(); // parses JSON response into native JavaScript objects

    }
    return (


        <>
            <section className="career-js">
                <Container>
                {data && data.map(({ job_title, location, department,no_of_openings,qualification
                        ,experince,profile,responsiblities,job_id}) => (
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                        
                            <div className="apply-sc">
                                <h2 className="pageinnerhead">{job_title} - {department}</h2>
                                <p>{location}</p>
                                <p><b>No of Openings: </b>{no_of_openings}</p>
                                <p><b>Qualification: </b> {qualification}</p>
                                <p><b>Experience: </b> {experince}</p>
                                <p><b>Profile: </b> {profile}</p>
                                <p><b>Responsiblities: </b>{responsiblities}</p>
                                
                                
                            </div>
                       
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                            <div className="apply-btn">
                            <a onClick={() => { routeChangeToCareer(job_id) }}>Apply For This Job</a>
                        </div>
                        </Col>
                    </Row>
                     ))}
                </Container>
            </section>

            {/* <section className="career-detail-sc">
                <Container>
                    <Row>
                        <Col xl={12}>
                            <div className="career-detail-pnl">
                                <h4>The Money Sukh Story:</h4>
                                <p>Mansukh is a well-known and experienced brokerage firm with its headquarters in New Delhi.  We have a large network of branches and franchisees in over 200 locations across India with regional offices located in Mumbai, Chandigarh, Chennai, and Kolkatta.  Member of the NSE, BSE, F&O, NCDEX, MCX, NSE Derivative Segment Self Clearing Member, and DP with NSDL and CDSL for shares and commodities. We provide a diverse range of Trading and Investment Solutions to all types of investors and traders. Promoted and led by a team of professionals with over 30 years of experience in the capital markets. We have an advanced in-house R&D wing with some of the best people, process, and technology resources to provide complete research solutions on equity, commodities, IPOs, and mutual funds. More than 1000 dedicated and highly motivated employees with diverse academic backgrounds such as CA, CS, ICWA, M.B.A, and IT.</p>

                                <h4>Position: Associate Manager - Accounts & finance</h4>
                                <p>(designation title can vary as per relevant experience)</p>

                                <h4>Rules & Responsiblities:</h4>
                                <ul>
                                    <li>In-time and accurate closure of books of account for reporting monthly, quarterly and annual financial results.</li>
                                    <li>Preparation of P&L statements and Balance Sheet. </li>
                                    <li>AP, AR and Banking Activities, Book Closure, BSRs, Stakeholder Management, issues resolution, Audits and cost optimization initiatives. </li>
                                    <li>Ensuring the timely tax compliance (TDS, GST, Advance tax).</li>
                                    <li>Ensuring compliance to Internal and Statutory Audit towards its timely & effective closure.</li>
                                    <li>Ensuring compliance towards timely and accurate Vendor payments.</li>
                                </ul>

                                <h3>Educational Qualifications & Certifications:</h3>
                                <h4>Qualified CS</h4>
                                <p>Experience/ Preferred Industry: 1-4 years Functional Competencies: </p>
                                <ul>
                                    <li>In-time and accurate closure of books of account for reporting monthly, quarterly and annual financial results.</li>
                                    <li>Preparation of P&L statements and Balance Sheet. </li>
                                    <li>AP, AR and Banking Activities, Book Closure, BSRs, Stakeholder Management, issues resolution, Audits and cost optimization initiatives. </li>
                                    <li>Ensuring the timely tax compliance (TDS, GST, Advance tax).</li>
                                    <li>Ensuring compliance to Internal and Statutory Audit towards its timely & effective closure.</li>
                                    <li>Ensuring compliance towards timely and accurate Vendor payments.</li>
                                </ul>

                                <h4>Psst… tips on how you can beat the competition: </h4>
                                <p>If you can showcase your abilities to:</p>
                                <ul>
                                    <li>Be self-driven / quick starter.</li>
                                    <li>Have an ownership mindset.</li>
                                    <li>Aggressively drive and deliver results.</li>
                                </ul>

                                <h4>If you fit the above description, we would love to connect with you! APPLY NOW</h4>
                                <p><strong>A basic requirement</strong> but one that many forget: Make sure you go through our website, download our app and give us feedback! </p>

                                <div className="apply-btn">
                                    <a href="">Apply For This Job</a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section> */}
        </>
    );
}
export default Career;